import { LocalizationProvider, StaticDatePicker, StaticDatePickerProps } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { TextField } from '../text-field/index';

type IStaticDatePickerProps = Omit<StaticDatePickerProps<Date>, 'renderInput'>;

export const StaticDateSelector = (props: IStaticDatePickerProps) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<StaticDatePicker
				inputFormat="dd-MM-yyyy"
				mask={'__-__-____'}
				renderInput={params => {
					return <TextField {...params} autoFocus={true} />;
				}}
				{...props}
			/>
		</LocalizationProvider>
	);
};
